import { Box, Circle, Flex, IconButton, Text } from '@chakra-ui/react'
import React, { useContext, useState } from 'react'
import { ColorContext } from '../Context/ColorContext'
import { BiArrowToLeft, BiArrowToRight } from "react-icons/bi";

const Colour = () => {
    const [state, setState] = useState(false)

    const { colors, setColors, underLineColor, textColor, family } = useContext(ColorContext)


    const Click = (val) => {
        console.log(val)
        setColors(val)
    }


    return (
        <Box>
            {state == true ? <Flex justifyContent={'end'} >
                <Flex borderTopLeftRadius={'5px'} borderBottomLeftRadius={'5px'} boxShadow={'rgba(6, 24, 44, 0.4) 0px 0px 0px 2px, rgba(6, 24, 44, 0.65) 0px 4px 6px -1px, rgba(255, 255, 255, 0.08) 0px 1px 0px inset;'}  justifyContent={"space-between"} alignItems={'center'} w={['60%','42%','30%','24%']}>
                    {state == true ? 
                    <IconButton bgColor={colors} color={'white'}><BiArrowToRight onClick={()=>setState(false)}/></IconButton> : " "}
                    <Circle cursor={'pointer'}  value={"#FBC02D"} onClick={(e) => Click('#FBC02D')} bgColor={'#FBC02D'} >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</Circle>
                    <Circle cursor={'pointer'}  onClick={(e) => Click("#1976D2")} bgColor={'#1976D2'} value={"#1976D2"}>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</Circle>
                    <Circle cursor={'pointer'}  onClick={(e) => Click('#0097A7')} bgColor={'#0097A7'} value={"#0097A7"}>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</Circle>
                    <Circle cursor={'pointer'} onClick={(e) => Click('#F57C00')} bgColor={'#F57C00'} value={"#F57C00"}>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</Circle>
                    <Circle cursor={'pointer'}  onClick={(e) => Click('#7B1FA2')} bgColor={'#7B1FA2'} value={"#7B1FA2"}>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</Circle>
                    <Circle cursor={'pointer'} onClick={(e) => Click('#D32F2F')} bgColor={'#D32F2F'} value={"#D32F2F"}>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</Circle>

                </Flex></Flex> : <Flex justifyContent={'end'}><IconButton bgColor={colors} color={'white'} textAlign={'end'} onClick={()=>setState(true)}><BiArrowToLeft /></IconButton></Flex>}

            {/* {state == true ? " " : } */}



        </Box>
    )
}

export default Colour
